<div class="container-sale">
  <!-- Datos generales -->
  <div class="card mb-3 shadow-sm">
    <div class="card-header text-white">
      <h3 class="mb-0">Pago de Tarjeta de Crédito</h3>
    </div>

    <div class="card-header bg-light">
      <h5 class="mb-0 fw-semibold text-primary">1. Datos generales</h5>
    </div>

    <div class="card-body row g-3">

      <div class="col-md-6 form-group">
        <label class="form-label fw-semibold">Cuenta bancaria a Debitar</label>
        <select class="form-select" [(ngModel)]="bankAccountNumberDebit">
          <option [ngValue]="null" disabled>Seleccione una cuenta</option>
          <option *ngFor="let account of filterAccountsDebit" [ngValue]="account.accountNumber">
            {{ account.alias }} - {{ account.accountNumber }}
          </option>
        </select>
      </div>

      <div class="col-md-6 form-group">
        <label class="form-label fw-semibold">Número de Tarjeta</label>
        <input
          class="form-control"
          type="text"
          [(ngModel)]="cardNumber"
          maxlength="16"
          placeholder="Ej. 1234567890123456">
      </div>

    </div>
  </div>

  <!-- Datos de transferencia -->
  <div class="card mb-3 shadow-sm">
    <div class="card-header bg-light">
      <h5 class="mb-0 fw-semibold text-primary">2. Datos de pago</h5>
    </div>

    <div class="card-body row g-3">

      <div class="col-md-4 form-group">
        <label class="form-label fw-semibold">Moneda</label>

        <div class="form-check form-switch">
          <input 
            class="form-check-input"
            type="checkbox"
            [(ngModel)]="isDollar"
            (change)="onCurrencyChange()">

          <label class="form-check-label fw-bold ms-2">
            {{ isDollar ? 'Dólares (USD)' : 'Quetzales (GTQ)' }}
          </label>
        </div>
      </div>

      <!-- Monto -->
      <div class="col-md-4 form-group">
        <label class="form-label fw-semibold">Monto</label>
        <div class="input-group">
          <span class="input-group-text">
            {{ isDollar ? '$' : 'Q' }}
          </span>
          <input
            class="form-control text-end"
            type="number"
            step="0.01"
            min="0"
            [(ngModel)]="amount"
            placeholder="0.00">
        </div>
      </div>

      <div class="col-md-4 form-group">
        <label class="form-label fw-semibold">Descripción</label>
        <input
          class="form-control"
          type="text"
          [(ngModel)]="description"
          placeholder="Ej. Pago tarjeta BAM">
      </div>

    </div>
  </div>

  <div class="text-center mt-4">
    <button class="btn btn-success btn-lg px-5" (click)="openConfirmModal()" [disabled]="loading">
      <ng-container *ngIf="loading">
        <span class="spinner-border spinner-border-sm"></span>
      </ng-container>
      <i class="fa fa-paper-plane me-2" *ngIf="!loading"></i>
      Enviar Pago
    </button>
  </div>
</div>

<app-modal-dialog
  [title]="'Confirmar Pago de Tarjeta'"
  [show]="confirmModalVisible"
  [showHeader]="true"
  [showFooter]="false"
  size="md"
  position="center"
  (closed)="onCancelTransfer()"
  (confirmed)="confirmTransfer()"
>
  <div modal-body>
    <div class="alert alert-warning d-flex align-items-center">
      <i class="fa fa-exclamation-triangle me-2"></i>
      <span>Revisa cuidadosamente los datos antes de confirmar el pago.</span>
    </div>

    <p class="fs-5">
      <strong>Monto:</strong>
      <span class="text-success fw-bold">
        {{ transferPreview?.currencySymbol }} {{ transferPreview?.amount | number:'1.2-2' }}
      </span>
    </p>

    <p>
      <strong>Descripción:</strong>
      <span class="text-muted">{{ transferPreview?.description }}</span>
    </p>

    <p>
      <strong>Número de Tarjeta:</strong>
      <span class="text-muted">{{ transferPreview?.cardNumber }}</span>
    </p>

    <p>
      <strong>Moneda:</strong>
      <span class="text-muted">{{ transferPreview?.currencyName }}</span>
    </p>

    <div class="card shadow-sm mb-2">
      <div class="card-body p-2">
        <h6 class="fw-bold text-primary mb-1">Cuenta Origen</h6>
        <div *ngIf="transferPreview?.debitAccount">
          <div>
            {{ transferPreview.debitAccount.accountNumber }} - {{ transferPreview.debitAccount.alias }}
          </div>
          <small class="text-muted">
            {{ getBankName(transferPreview.debitAccount.bank) }}
          </small>
        </div>
      </div>
    </div>

    <div class="card shadow-sm mb-2">
      <div class="card-body p-2">
        <h6 class="fw-bold text-primary mb-1">Código</h6>

        <div *ngIf="!showInputCode">
          <button class="btn btn-link" [disabled]="loadingSendCode" (click)="sendRequestCode()">
            Solicitar Código
            <span *ngIf="loadingSendCode" class="spinner-border spinner-border-sm me-2"></span>
          </button>
        </div>

        <div *ngIf="showInputCode">
          <div class="input-group">
            <input
              class="form-control"
              type="text"
              [(ngModel)]="code2fa">

            <button class="btn btn-success" (click)="pastClipboard()">
              <i class="fa fa-clipboard"></i>
            </button>
          </div>

          <button class="btn btn-link" [disabled]="loadingSendCode" (click)="sendRequestCode()">
            Volver a solicitar código
            <span *ngIf="loadingSendCode" class="spinner-border spinner-border-sm me-2"></span>
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="card-body p-3">
        <div class="col">
          <button class="btn btn-secondary btn-block" (click)="onCancelTransfer()">
            Cancelar
          </button>

          <button
            class="btn btn-primary btn-block"
            (click)="confirmTransfer()"
            *ngIf="showInputCode && code2fa">
            Finalizar
          </button>
        </div>
      </div>
    </div>

  </div>
</app-modal-dialog>
